import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionSummary, AccordionDetails, Grid } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Import PageSettings component
import PageSettings from "./PageSettings";
import { usePermissions } from "context/PermissionsContext";

const GeneralSettings = ({ showAlert, api }) => {
  const { t } = useTranslation();
  const [expandedPanel, setExpandedPanel] = useState("page-settings-own");
  const { hasPermission } = usePermissions();

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  return (
    <SoftBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {/* Page Settings Section (Own) */}
          <Accordion
            expanded={expandedPanel === "page-settings-own"}
            onChange={handleAccordionChange("page-settings-own")}
            sx={{
              mb: 2,
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
              "&::before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="page-settings-own-content"
              id="page-settings-own-header"
            >
              <SoftTypography variant="h6">{t("lang.page_settings_own")}</SoftTypography>
            </AccordionSummary>
            <AccordionDetails>
              <PageSettings showAlert={showAlert} api={api} />
            </AccordionDetails>
          </Accordion>

          {hasPermission("can_manage_settings_for_all_users") && (
            <>
              {/* Page Settings Section (Global) */}
              <Accordion
                expanded={expandedPanel === "page-settings-global"}
                onChange={handleAccordionChange("page-settings-global")}
                sx={{
                  mb: 2,
                  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
                  "&::before": {
                    display: "none",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="page-settings-global-content"
                  id="page-settings-global-header"
                >
                  <SoftTypography variant="h6">{t("lang.page_settings_global")}</SoftTypography>
                </AccordionSummary>
                <AccordionDetails>
                  <PageSettings isGlobal={true} showAlert={showAlert} api={api} />
                </AccordionDetails>
              </Accordion>
            </>
          )}
        </Grid>
      </Grid>
    </SoftBox>
  );
};

GeneralSettings.propTypes = {
  showAlert: PropTypes.func.isRequired,
  api: PropTypes.object.isRequired,
};

export default GeneralSettings;
